/**
 * Container Sizes
 * 
 * Provides consistent container sizing for atomic components.
 * The tenant system doesn't have container size scales.
 */
export const containerSizes = {
  /** Circular icon containers */
  circularIcon: {
    sm: '40px',
    md: '44px',
    lg: '64px',
  },
  /** Avatar sizes — profile images, agent photos */
  avatar: {
    /** 40px — Compact contexts (inline banners, sidebar cards) */
    sm: '40px',
    /** 56px — Default contexts (floating toasts, standalone cards) */
    md: '56px',
  },
  /** Image gallery heights - matches legacy swiper carousel */
  gallery: {
    /** Mobile gallery height (18em = ~288px) */
    mobile: '18em',
    /** Desktop gallery height (21em = ~336px) */
    desktop: '21em',
  },
  /** Pagination bullet size */
  paginationBullet: '10px',
} as const;

export type ContainerSizes = typeof containerSizes;
